module.exports = __webpack_public_path__ + "assets/img/Logitech-G-2-Social-Static-Ad-w960.676b2f0d.webp";